import { render, staticRenderFns } from "./PlanoContas.vue?vue&type=template&id=7c43630e&scoped=true"
import script from "./PlanoContas.vue?vue&type=script&lang=js"
export * from "./PlanoContas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c43630e",
  null
  
)

export default component.exports